import { css } from 'aphrodite';
import { ComponentProps, FC } from 'react';
import { styleSheet } from './styles';

interface LayoutProps {
	center?: boolean;
	fullHeight?: boolean;
	fullWidth?: boolean;
	scrollable?: boolean;
}

export const Page: FC<AphroditeStyled<ComponentProps<'div'>> & { scrollable?: boolean }> = ({
	children,
	scrollable = false,
	styles = [],
	...rest
}) => {
	return (
		<div data-testid='page' className={css(styleSheet.page, scrollable && styleSheet.scrollable, ...styles)} {...rest}>
			{children}
		</div>
	);
};

export const Column: FC<AphroditeStyled<ComponentProps<'div'>> & LayoutProps> = ({
	children,
	center = false,
	fullHeight = false,
	fullWidth = false,
	scrollable = false,
	styles = [],
	...rest
}) => {
	return (
		<div
			className={css(
				styleSheet.column,
				scrollable && styleSheet.scrollable,
				fullHeight && styleSheet.fullHeight,
				fullWidth && styleSheet.fullWidth,
				center && styleSheet.center,
				...styles
			)}
			{...rest}
		>
			{children}
		</div>
	);
};

export const Row: FC<AphroditeStyled<ComponentProps<'div'>> & LayoutProps> = ({
	children,
	center = false,
	fullHeight = false,
	fullWidth = false,
	scrollable = false,
	styles = [],
	...rest
}) => {
	return (
		<div
			className={css(
				styleSheet.row,
				scrollable && styleSheet.scrollable,
				fullHeight && styleSheet.fullHeight,
				fullWidth && styleSheet.fullWidth,
				center && styleSheet.center,
				...styles
			)}
			{...rest}
		>
			{children}
		</div>
	);
};
